import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const brokerApi = createApi({
  reducerPath: 'brokerApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Broker', 'BrokerList', 'Commission', 'CommissionList'],
  endpoints: () => ({})
})

export default brokerApi
